import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from '../helpers/history';

import c from '../helpers/constants';
import { fetchCustomer } from '../actions/Customer';
import likewiseLogo from '../assets/svgs/likewise-logo.svg';
import { didFetchingCustomerFailed } from '../selectors/Customer';
import '../styles/Login.scss';
import Button from '../components/Button';
import TextInput from '../components/TextInput';
import { getCustomer } from '../selectors/Customer';
import LWModal from '../components/Modal';
import { emailForgotPassword } from '../actions/Email';

const Login = () => {
  const dispatch = useDispatch();
  const [customerId, setCustomerId] = useState('');
  const [postcode, setPostcode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const fetchingFailed = useSelector(didFetchingCustomerFailed);
  const customer = useSelector(getCustomer);
  const [toggle, setToggle] = useState(false);
  const [name, setName] = useState('');
  const [cname, setCName] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const onLogin = async () => {
    setIsLoading(true);
    await dispatch(fetchCustomer(customerId, postcode));
    setIsLoading(false);
  };

  useEffect(() => {
    if (!fetchingFailed && customer !== null) {
      history.push(c.APP_ROUTES.DASHBOARD);
    }
  }, [customer]);

  const isFormReady = postcode?.length > 0 && customerId.length > 0;
  const onContact = () => {
    window.location.href = 'mailto:webenquiries@likewise.co.uk';
  };

  const onForgotPassword = async () => {
    await dispatch(emailForgotPassword(
      {
        contactEmail: email,
        contactName: cname,
        contactTel: tel,
        customerName: name,
      },
    ));
    setName('');
    setCName('');
    setEmail('');
    setTel('');
    setEmailSent(true);
  };

  return (
        <div>
            <div className="page-container">
                <div className="login-container">
                    <img alt="Likewise Logo" src={likewiseLogo}/>
                    <div className="pt-4 pb-3">Sign in to Likewise Floors</div>
                    {fetchingFailed && <div className="pt-2 pb-2 text-danger">Wrong customer number or postcode</div>}
                    <div className="mb-3 input-container">
                        <TextInput label="Customer Account Number" id="customerId" bgColor="grey" name="customerId"
                                   value={customerId}  onBlur={(e) => setCustomerId(e)}
                                   onChange={(e) => setCustomerId(e)}
                                   placeholder="Enter your customer account number here" />
                    </div>
                    <div className="mb-3 input-container">
                        <TextInput label="Password" bgColor="grey" id="postcode" name="postcode"
                                   value={postcode}  onBlur={(e) => setPostcode(e)}
                                   type="password"
                                   onChange={(e) => setPostcode(e)}
                                   placeholder="Enter your password here" />
                    </div>
                    <div className="mt-3 input-container">
                        <Button disabled={isLoading || !isFormReady} onClick={onLogin} size="stretch" text={isLoading ? 'Loading...' : 'Sign In'} />
                    </div>
                    <div className="mt-3 text-center">
                        <Button onClick={() => setToggle(true)} type="link" text="Forgot Password" />
                    </div>
                    <div className="mt-3 text-center">
                        <p>Don&apos;t have an account?</p>
                        <Button onClick={onContact} type="link" text="Contact Our Support Team" />
                    </div>
                </div>
            </div>
            <LWModal title="Forgot Password" onClose={() => {
              setToggle(false);
              setEmailSent(false);
            }}
                     show={toggle}>
                {!emailSent &&
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <TextInput label="Customer Name" id="name" bgColor="grey" name="name"
                                           value={name}  onBlur={(e) => setName(e)}
                                           onChange={(e) => setName(e)}
                                           placeholder="Enter your customer name here" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TextInput label="Contact Name" id="cname" bgColor="grey" name="cname"
                                           value={cname}  onBlur={(e) => setCName(e)}
                                           onChange={(e) => setCName(e)}
                                           placeholder="Enter your contact name here" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TextInput label="Contact Email" id="email" bgColor="grey" name="email"
                                           value={email}  onBlur={(e) => setEmail(e)}
                                           onChange={(e) => setEmail(e)}
                                           placeholder="Enter your contact email here" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TextInput label="Contact Phone" id="tel" bgColor="grey" name="tel"
                                           value={tel}  onBlur={(e) => setTel(e)}
                                           onChange={(e) => setTel(e)}
                                           placeholder="Enter your contact phone here" />
                            </div>
                        </div>
                        <div className="row mt-5">
                            <Button text="Request Password" disabled={!email || !tel || !cname || !name} onClick={onForgotPassword}/>
                        </div>
                    </div>
                }
                {emailSent && <div className="alert alert-success" role="alert">
                    Our support team will be in touch soon to help resolve this issue.
                </div>}
            </LWModal>
        </div>
  );
};

export default Login;
